export const filterOptions = [
  { value: "all", label: "All" },
  { value: "client", label: "Client" },
  { value: "supplier", label: "Supplier" },
  { value: "admin", label: "Admin" },
]
